export default "__VITE_ASSET__truWHYZu__"